<template>
    <div :style="{'height':clientHeight-90+'px'}">
        <div>
            <div class="m-portlet m-b-10" :style="{'height':(80)+'px'}">
                <div class="m-portlet__body">
                    <el-form>
                        <el-form-item label="筛选学期">
                            <el-select v-model="semester_id" placeholder="请选择学期" @change="changeSemester()">
                                <el-option
                                        v-for="item in semesters"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="m-portlet m-b-10" :style="{'height':(130)+'px'}">
                <div class="m-portlet__body" :style="{'height':130+'px'}" v-loading="loading">
                    <table class="table table-striped" v-loading="loading">
                        <thead>
                        <tr>
                            <th>校区</th>
                            <th>{{twoSemester.name}}老生/{{oneSemester.name}}有课学生人数</th>
                            <th>{{twoSemester.name}}老生报班数/{{oneSemester.name}}有课学生报班数</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{{organization.name}}</td>
                            <td>{{organization.organization_students_renewalRate}}</td>
                            <td>{{organization.organization_classes_renewalRate}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="m-portlet m-b-0" :style="{'height':(clientHeight-330)+'px'}">
                <div class="m-portlet__body" v-loading="loading" :style="{'height':clientHeight-380+'px'}">
                    <el-table
                            :data="orderHeadTeachers"
                            style="width: 100%"
                            size="middle"
                            :height="clientHeight-420">
                        <el-table-column prop="name" label="班主任"></el-table-column>
                        <el-table-column prop="headTeacher_students_renewalRate">
                            <template slot="header" slot-scope="scope">
                                {{twoSemester.name}}老生/{{oneSemester.name}}有课学生人数
                            </template>
                        </el-table-column>
                        <el-table-column prop="headTeacher_classes_renewalRate">
                            <template slot="header" slot-scope="scope">
                                {{twoSemester.name}}老生报班数/{{oneSemester.name}}有课学生报班数
                            </template>
                        </el-table-column>
                    </el-table>

                    <!--分页-->
                    <div class="text-center m-t-10">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                path: "/renewalOrganization/list",
                semesters: [],
                sections: [],
                organization: [],
                oneSemester: [],
                twoSemester: [],
                headTeachers: [],
                loading: 'true',
                semester_id: '',
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
            }
        },
        created() {
            this.handleCreate();
            this.handleShow();
            this.handleSectionIndex();
            this.semester_id = this.$store.state.config.nowSemester.id;
        },
        computed: {
            orderHeadTeachers: function () {
                return this._.values(this.headTeachers);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleShow() {
                this.$wApi.send(this.path, 'init', {
                    'localStorage': localStorage.baseUrl,
                });
            },
            handleData(event, data) {
                switch (event) {
                    case 'init':
                        this.semesters = data.semesters;
                        break;
                    case 'list':
                        this.total = data.total;
                        this.organization = data.organization;
                        this.oneSemester = data.oneSemester;
                        this.twoSemester = data.twoSemester;
                        this.section = data.section;
                        this.headTeachers = data.headTeachers;
                        this.loading = false;
                        break;
                }
            },
            changeSemester() {
                this.loading = true;
                this.handleSectionIndex();
            },
            handleSectionIndex(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize,
                    'semester_id': this.semester_id,
                    'nowSemester_id': this.$store.state.config.nowSemester.id,
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleSectionIndex(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleSectionIndex(this.currentPage, this.currentPageSize)
            },
        }
    }
</script>

<style scoped>

</style>
